import Modal from 'react-modal'
import './login-modal.css';
import agent from '../agent';
import React from 'react';
import LoginFeedbackModal from './LoginFeedbackModal.js'
import { BACKEND_URL } from '../constants/constants';

class SGIDConfirmationModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fullName: '',
      preferredName: '',
      sex: ''
    }
  }

  openLoginPrompt = (fullName, preferredName, sex) => {
    this.setState({ fullName });
    this.setState({ preferredName });
    this.setState({ sex });
    this.setState({ showLoginPrompt: true });
  }
  
  closeLoginPrompt = () => {
    this.setState({ showLoginPrompt: false });
  }

  goBack = (event) => {
    if (event) event.preventDefault()
    this.closeLoginPrompt()
    let container = this.props.container
    container.openLoginPrompt()
  }

  confirmSelection = (event) => {
    if (event) event.preventDefault()
    agent.Profile.setPreferredName(this.state.preferredName)
    .then((user) => {
      this.closeLoginPrompt()
      this.refs.loginFeedbackModal.openLoginFeedback(this.state.preferredName)
      this.setState({ showError: false });
    })
    .catch(error => {
      this.setState({ showError: true });
    })
  }

  render() {

    const redirectEndpoint = `${BACKEND_URL}/redirect?state=${this.state.handle}`

    return (
      <div>
        <Modal
          isOpen={this.state.showLoginPrompt}
          onRequestClose={this.closeLoginPrompt}
          className="Modal"
          overlayClassName="Overlay">
          <div className="title">We care about having constructive conversations.</div>
          <div className="info">While leaders get to know more about the people asking them questions, the full names of followers will not be revealed to the general public.</div>
          <div className="summary">Leaders will view you as:</div>
          <div className="preferred-name"> { this.state.fullName }</div>
          <div className="sex">{ this.state.sex }</div>
          <div className="summary">Other users will view you as:</div>
          <div className="preferred-name"> { this.state.preferredName }</div>
          <div className="btn-container">
            <div className="resetBtn" onClick={this.goBack}>
              Back
            </div>
            <div className="confirmBtn" onClick={this.confirmSelection}>
              Confirm
            </div>
          </div>
          <div className="cancel" onClick={this.openLoginModal}>Cancel</div>
        </Modal>
        <LoginFeedbackModal container={this} ref="loginFeedbackModal"/>
      </div>
    ); 
  }
}

export default SGIDConfirmationModal






// WEBPACK FOOTER //
// ./src/components/SGIDConfirmationModal.js